import { AuthenticatedHttp } from '@/http/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNotify } from '@/components/snackbar';

export function useCreateApiKey() {
    const notify = useNotify();
    const queryClient = useQueryClient();

    const createApiKeyMutation = useMutation({
        mutationFn: async (formData) => {
            const formatScopesSelected = formData.scopes.join(' ');

            const { data } = await AuthenticatedHttp.post('/public_api/api_key/', {
                name: formData.name,
                scope: formatScopesSelected,
            });

            return data;

        },
        onSuccess: (data) => {
            notify.success('Chave de API criada com sucesso!');
            queryClient.invalidateQueries({ queryKey: ['api-keys'] });
            return data;
        },
        onError: (error) => {
            console.error('Erro ao criar API key:', error);

            const nameError = error?.response?.data?.name

            if (nameError) {
                return notify.error('Já existe uma Chave de API com este nome.');
            }

            // O `detail` do backend diz por que a criação foi recusada (ex.: conta bloqueada,
            // CKTPL-1398); "tente novamente" mandaria repetir o que vai falhar de novo.
            return notify.error(
                error?.response?.data?.detail || 'Erro ao criar chave de API. Tente novamente.'
            );
        }
    });

    return {
        createApiKey: createApiKeyMutation.mutate,
        isLoading: createApiKeyMutation.isLoading,
        error: createApiKeyMutation.error,
        data: createApiKeyMutation.data,
    };
}
